import { graphql, useStaticQuery } from 'gatsby';
import { useMixpanel } from 'gatsby-plugin-mixpanel';
import React, { ReactElement } from 'react';
import { Headline, Link, Text } from '../../components';
import LibraryThumbnail from '../library-thumbnail';
import './style.css';

// Displays the 3 most recent items added to the Library
export default function LibraryNew(): ReactElement {
  const mixpanel = useMixpanel();

  const data = useStaticQuery(graphql`
    query LibraryNewQuery {
      allStrapiLibraryPost(sort: { date: DESC }, limit: 6) {
        nodes {
          title
          url
          categories {
            name
          }
          author {
            name
            image {
              url
            }
          }
        }
      }
    }
  `);

  const handlePostClick = (category, title, url) => (e) => {
    mixpanel.track('Library post clicked', {
      category,
      title,
      url,
    });
  };

  return (
    <div className="library-new mb-16">
      {data.allStrapiLibraryPost.nodes.map(
        ({ url, title, author, categories }) => {
          return (
            <Link
              key={url}
              onClick={handlePostClick(categories[0].name, title, url)}
              className="library-new__card rounded-lg pb-10 pl-6 pr-6 pt-6"
              href={url}
              target="_blank"
              aria-label={title}
              rel="noreferrer">
              <LibraryThumbnail
                url={
                  author.image
                    ? author.image.url
                    : 'https://res.cloudinary.com/stark-lab/image/upload/v1669148590/default_author_f18d200691.png'
                }
                name={author.name}
              />

              <Text
                level="mono"
                color="purple"
                className="library-new__card__category mb-2 mt-3">
                {categories[0].name}
              </Text>

              <Headline level="4" className="library-new__card__title mb-2">
                {title}
              </Headline>
            </Link>
          );
        }
      )}
    </div>
  );
}
